<template>
    <div>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn class="font-weight-light" tile color="black" dark  @click="btn_add"  >
                        <v-icon >add</v-icon>Product
                    </v-btn>
                </v-toolbar>
            </template>
        </v-container>

        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.descrip }}</td>
                <td class="text-xs-left">{{ props.item.price }}</td>
                <td class="text-xs-left">{{ props.item.category }}</td>
                <td class="text-xs-center">{{ props.item.active }}</td>
                <td class="text-xs-left" ><img :src="url + props.item.image " class="image"  width="50px" height="50px"></td>
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="edit_prod(props.item.code)">edit</v-icon>
                </td>

                </template>

            </v-data-table>

            
        </v-container>

    </div>
</template>

<script>
import axios from "axios"
export default {

data() {
    return {
            /** กำหนด headers ให้ตรง */
            headers:[ 
              { text: 'Code', value: 'code' },
              { text: 'Name', value: 'name' },
              { text: 'details', value: 'address' },
              { text: 'price', value: 'tel' },
              { text: 'category', value: 'location' },
              { text: 'active', value: 'active' },
              { text: 'image', value: 'image' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            table_details:[],
            users: [],
            search: '',
            current_cust_code : '',
            current_cust_name : '',
            url : "https://ws.plantifulbkk.shop/images/" ,
        }
    },
    created () {
      console.log("CREATE")
      this.read_data()
    },

    methods :{
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_product.php').then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.users = result
            console.log(vm.users)
            });
        },
        edit_prod(item){
            this.$store.dispatch('set_user_ac_editer', '1'  )
            this.$store.dispatch('set_user_ac_code', item  )
            this.$router.push('/editproduct')
        },
        btn_add(){
            this.$store.dispatch('set_user_ac_editer', '0'  )
            this.$router.push('/addproduct')
        },
    },
    

}


</script>

<style>
 
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

H2 {
  font-family: 'Mitr', sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/pages/product.vue